/**
 * Give the rendered page's effects/data loads a head start before optional nav
 * reads. Then wait for browser idle, with a bounded fallback on busy browsers.
 * The caller must invoke this from a post-render effect and cancel on cleanup.
 */
export function deferNavBadgeRead(read: () => void): () => void {
  let cancelled = false;
  let idleId: number | undefined;
  const timer = globalThis.setTimeout(() => {
    if (cancelled) return;
    if (typeof globalThis.requestIdleCallback === 'function') {
      idleId = globalThis.requestIdleCallback(
        () => {
          if (!cancelled) read();
        },
        { timeout: 5_000 },
      );
    } else {
      read();
    }
  }, 1_500);
  return () => {
    cancelled = true;
    globalThis.clearTimeout(timer);
    if (idleId !== undefined && typeof globalThis.cancelIdleCallback === 'function') {
      globalThis.cancelIdleCallback(idleId);
    }
  };
}
